window.AuthTokenDispatch = {
  initiated: function () {
    if (window.webkit) {
      window.webkit.messageHandlers.authTokenDispatchInitiated.postMessage("");
    } else if (typeof messageHandlers != "undefined") {
      messageHandlers.authTokenDispatchInitiated();
    }
  },
  fetched: function (token) {
    if (window.webkit) {
      window.webkit.messageHandlers.authTokenDispatchFetched.postMessage(token);
    } else if (typeof messageHandlers != "undefined") {
      messageHandlers.authTokenDispatchFetched(token);
    }
  },
  revoked: function () {
    if (window.webkit) {
      window.webkit.messageHandlers.authTokenDispatchRevoked.postMessage("");
    } else if (typeof messageHandlers != "undefined") {
      messageHandlers.authTokenDispatchRevoked();
    }
  },
};
